module.exports = __webpack_public_path__ + "static/img/4.733fb1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/sp/4.png
// module id = 5Tqj
// module chunks = 0